"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchGamesInWithPagination = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var game_api_1 = require("@l2p/game-api");
var react_1 = require("react");
var __1 = require("../");
var currencies_1 = require("../currencies");
var games_1 = require("../games");
var geo_1 = require("../geo");
var useSearchGamesInWithPagination = function (_a) {
    var showCount = _a.showCount, categoryId = _a.categoryId, providerId = _a.providerId, successAction = _a.successAction, place = _a.place;
    var SEARCH_VALUE_GAMES_PAGINATION = (0, react_1.useMemo)(function () { return "search_value_games_pagination".concat(place || ''); }, [place]);
    var SEARCH_LIMIT_GAMES_PAGINATION = (0, react_1.useMemo)(function () { return "search_limit_games_pagination".concat(place || ''); }, [place]);
    var _b = (0, __1.useCache)(), getDataFromCache = _b.getDataFromCache, setDataToCache = _b.setDataToCache;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var initialShowCount = (0, react_1.useMemo)(function () { return getDataFromCache(SEARCH_LIMIT_GAMES_PAGINATION) || showCount; }, [getDataFromCache, showCount, SEARCH_LIMIT_GAMES_PAGINATION]);
    var _c = (0, react_1.useState)(initialShowCount), showGames = _c[0], setShowGames = _c[1];
    var _d = (0, games_1.useSearchGames)({
        successAction: successAction,
    }), searchGames = _d.searchGames, data = _d.data, isSubmitting = _d.isSubmitting, error = _d.error;
    var _e = (0, geo_1.useGeo)(), geoData = _e.data, isGeoLoading = _e.isLoading;
    var prevCurrency = (0, react_1.useRef)(null);
    var filterPayload = (0, react_1.useMemo)(function () {
        var _a, _b;
        var searchValue = getDataFromCache(SEARCH_VALUE_GAMES_PAGINATION);
        return {
            devices: [
                breakpoints.mobile || breakpoints.tablet
                    ? game_api_1.GameDeviceTypeEnum.Mobile
                    : game_api_1.GameDeviceTypeEnum.Desktop,
                game_api_1.GameDeviceTypeEnum.Universal,
            ],
            categoryId: categoryId,
            providers: providerId ? [providerId] : undefined,
            allowedCountries: ((_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode)
                ? [(_b = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _b === void 0 ? void 0 : _b.countryCode]
                : undefined,
            currencies: currentCurrency ? [currentCurrency] : undefined,
            title: searchValue ? searchValue : undefined,
        };
    }, [
        breakpoints,
        geoData,
        currentCurrency,
        categoryId,
        getDataFromCache,
        providerId,
    ]);
    var loadMoreHandler = (0, react_1.useCallback)(function () {
        var limit = showGames + initialShowCount;
        var searchValue = getDataFromCache(SEARCH_VALUE_GAMES_PAGINATION);
        searchGames({
            page: 0,
            limit: limit,
            filter: __assign(__assign({}, filterPayload), { title: searchValue ? searchValue : undefined }),
        });
        setShowGames(limit);
        setDataToCache(SEARCH_LIMIT_GAMES_PAGINATION, limit);
    }, [
        getDataFromCache,
        searchGames,
        showGames,
        setShowGames,
        initialShowCount,
        filterPayload,
        setDataToCache,
    ]);
    var searchHandler = (0, react_1.useCallback)(function (payload) {
        if (payload === void 0) { payload = {}; }
        var searchValue = getDataFromCache(SEARCH_VALUE_GAMES_PAGINATION);
        searchGames({
            page: 0,
            limit: initialShowCount,
            filter: __assign(__assign(__assign({}, filterPayload), { title: searchValue ? searchValue : undefined }), payload),
        });
        setShowGames(initialShowCount);
    }, [
        searchGames,
        showGames,
        setShowGames,
        initialShowCount,
        filterPayload,
        getDataFromCache,
    ]);
    (0, react_1.useEffect)(function () {
        if (isGeoLoading ||
            Object.keys(breakpoints).length === 0 ||
            prevCurrency.current === currentCurrency)
            return;
        var searchValue = getDataFromCache(SEARCH_VALUE_GAMES_PAGINATION);
        searchGames({
            page: 0,
            limit: initialShowCount,
            filter: __assign(__assign({}, filterPayload), { title: searchValue ? searchValue : undefined }),
        });
        prevCurrency.current = currentCurrency;
    }, [
        getDataFromCache,
        initialShowCount,
        filterPayload,
        currentCurrency,
        breakpoints,
        geoData,
        showGames,
        searchGames,
        isGeoLoading,
    ]);
    return (0, react_1.useMemo)(function () { return ({
        data: data,
        loadMore: loadMoreHandler,
        search: searchHandler,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [isSubmitting, data, loadMoreHandler, error, searchHandler]);
};
exports.useSearchGamesInWithPagination = useSearchGamesInWithPagination;
